import styled from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';
import { tagStyles } from '../../../ui/Typography/styles';
import { FlexColumn, FlexibleDiv } from '../../../../styled/common';
import { ItemCardStyled } from '../../../ui/ItemCard/styled';

export const ResidenceItemsContainer = styled(FlexColumn)`
  padding: 30px 0;
  margin-top: 20px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  gap: 20px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 30px 0;
    margin-top: 15px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin-top: 30px;
    border-radius: 14px;
  }
`;

export const ResidenceItemsHead = styled(FlexibleDiv)`
  gap: 20px;
  justify-content: space-between;
  padding: 0 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    gap: 15px;
    padding: 0 40px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 10px;
  }
`;

export const ResidenceItemsDescription = styled(FlexColumn)`
  gap: 10px;

  @media (min-width: ${Breakpoints.tablet}px) {
    gap: 5px;
  }
`;

export const ResidenceItemsTitle = styled(Typography)`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${tagStyles.title_3_desc};
    line-height: 20px;
  }
`;

export const ResidenceItemsCount = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ResidenceItemsList = styled(FlexibleDiv)<{
  $isFirstRender: boolean;
}>`
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 15px;

  ${({ $isFirstRender, theme }) =>
    $isFirstRender &&
    `
    @media (max-width: ${theme.tabletBreakpoint}) {
      ${ItemCardStyled}:nth-child(n + 7) {
        display: none;
      }
    }

    @media (max-width: ${theme.desktopBreakpoint}) {
      ${ItemCardStyled}:nth-child(n + 10) {
        display: none;
      }
    }
  `}

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 40px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    ${ItemCardStyled} {
      flex: 1 1 calc(100% / 5);
      max-width: calc((100% / 5) - 10px);
    }
  }
`;
